import { Fragment } from "react";

function ZPatternTwoSectionCard({
  bg,
  bg_image,
  title_text,
  button_text,
  heading_color = "#1a7a45", // Fallback default color if none passed
  onButtonClick,
  children,
}) {
  return (
    <Fragment>
      <div className="zpattern-two-sections-card">
        <div className="zpattern-left-section-card">
          <div
            className="badget-title"
            style={{ color: "white", backgroundColor: heading_color }}
          >
            {title_text}
          </div>
          <div className="zpattern-banner-card">
            <img
              src={`${process.env.PUBLIC_URL}/images/${bg_image}`}
              alt="Background Image"
            />
          </div>
          {/* Apply Heading Color to text */}
        </div>

        <div className="zpattern-right-section-card">
          {children}
          <div
            style={{ display: "flex", width: "100%", justifyContent: "end" }}
          >
            <button
              className="cta-button secondary"
              onClick={onButtonClick}
              style={{ width: "100%" }}
            >
              {button_text}
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default ZPatternTwoSectionCard;
